import { format } from 'date-fns';

const FILENAME_PREFIX = 'flight-report';
const DATE_FORMAT = 'yyyy-MM-dd-HHmmss';

const formatPdfFilename = (): string => `${FILENAME_PREFIX}-${format(new Date(), DATE_FORMAT)}.pdf`;

export default formatPdfFilename;
